"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M21 17.5c0 1.3807-1.1193 2.5-2.5 2.5S16 18.8807 16 17.5s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5z",
    fill: "#0058A3"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.2379 5.0727c.7298-.7504 1.7004-1.0766 2.7838-1.0766.6909 0 1.3439.1494 1.9297.477.5916.331 1.0513.8119 1.376 1.4125.3399.6212.482 1.3367.482 2.0996 0 1.1348-.3034 2.158-1.044 2.9207-.7271.7563-1.6937 1.0896-2.7755 1.0896-.6867 0-1.3361-.1506-1.9235-.4736l-.0062-.0035c-.5927-.3314-1.0528-.8134-1.3777-1.4154l-.0031-.0058c-.3342-.629-.4772-1.3464-.4772-2.112 0-1.1315.2981-2.1542 1.0357-2.9125zm2.7838.9245c-.6689 0-1.0759.1894-1.3493.4706-.2657.2732-.4692.7272-.4692 1.5174 0 .5185.0965.8953.2419 1.1704.1546.2854.35.4803.5888.6147.2598.1421.5703.2241.956.2241.655 0 1.0581-.1888 1.334-.4764l.0048-.005c.275-.2827.4796-.7422.4796-1.5278 0-.5218-.0976-.8862-.237-1.1404l-.0033-.0059c-.1555-.2882-.3524-.4845-.5934-.6193-.2479-.1387-.5558-.2224-.9529-.2224z"
  }), _react.default.createElement("path", {
    d: "M7.759 15.501c-.5671.3299-.9916.7769-1.2899 1.3572C6.166 17.4478 6 18.1518 6 18.9961v1H4v-1c0-1.1122.2205-2.1384.6904-3.0523.4743-.9225 1.1689-1.6525 2.0671-2.174.9742-.5617 2.108-.7737 3.2225-.7737h4.04c.82 0 1.587.1114 2.2863.3511l-1.6773 1.6773a6.2932 6.2932 0 0 0-.609-.0284H9.98c-.9375 0-1.6627.1858-2.221.5049z"
  })];
};

exports.default = _default;